
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-lock",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-lock"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M3.9 8h10.13v8.07H3.9zm2.01 0V5A3.08 3.08 0 019 1.93 3.08 3.08 0 0112.07 5v3"}})])
          )
        }
      }
    